import type { Account, SourceAccount } from '@repo/api-gw-sdk';

import { CloudProviderIndicator } from '@/components/cloudProviderIndicator';

import { TextDetailsTuple } from '../text/textDetailsTuple';

export const AccountIndicator = ({
  account,
  showCloudIndicator = true,
  showAccountName = true,
  showAccountId = true,
}: {
  account: Account | SourceAccount;
  showCloudIndicator?: boolean;
  showAccountName?: boolean;
  showAccountId?: boolean;
}) => {
  const cloudProvider =
    'cloudProvider' in account
      ? account.cloudProvider
      : account.sourceAccountAttributes.cloudProvider;

  return showCloudIndicator ? (
    <CloudProviderIndicator
      cloudProvider={cloudProvider}
      text={
        <TextDetailsTuple
          primaryProp={showAccountName ? account.name : undefined}
          secondaryProp={showAccountId ? account.providerAccountId : undefined}
        />
      }
    />
  ) : (
    <TextDetailsTuple
      primaryProp={showAccountName ? account.name : undefined}
      secondaryProp={showAccountId ? account.providerAccountId : undefined}
    />
  );
};
